import React, { ReactNode } from 'react';

import classNames from 'classnames';

import './label-value-item.scss';

interface LabelValueItemProps {
  title: string;
  text: string | number | ReactNode;
  sm?: boolean;
}

const LabelValueItem: React.FC<LabelValueItemProps> = ({ title, text, sm }) =>
  text ? (
    <div
      className={classNames('item', {
        'item--sm': sm,
      })}
    >
      <div className="item__title">{title}</div>
      <div className="item__text">{text}</div>
    </div>
  ) : null;

export default LabelValueItem;
